import { Play } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { VIDEO_INTERVIEW_URL } from "@/data/content";

export const VideoFeature = () => (
  <section className="relative bg-teal-subtle py-16 sm:py-20 overflow-hidden" data-testid="video-feature-section">
    <div className="absolute -left-32 top-1/3 h-96 w-96 rounded-full bg-teal/15 blur-[120px]" />
    <div className="absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-ember/15 blur-[100px]" />
    <div className="relative mx-auto max-w-6xl px-6">
      <Reveal className="text-center mb-12">
        <Eyebrow>In conversation</Eyebrow>
        <h2 className="font-display font-extrabold tracking-tight text-coal text-4xl sm:text-5xl mt-4">
          Marc Lottering <span className="text-ember">x</span> Latifah Charles
        </h2>
        <p className="text-coal-muted mt-4 max-w-2xl mx-auto text-base md:text-lg">
          A local legend sits down with our founder to talk literacy, storytelling and the power of
          young voices in Cape Town.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="relative mx-auto max-w-4xl">
          <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-r from-teal/40 via-transparent to-ember/40 blur-xl opacity-60" />
          <div className="relative aspect-video overflow-hidden rounded-3xl border border-sand/10 bg-coal shadow-2xl">
            {VIDEO_INTERVIEW_URL ? (
              <video
                data-testid="interview-video"
                src={VIDEO_INTERVIEW_URL}
                controls
                preload="metadata"
                playsInline
                className="h-full w-full object-cover"
              />
            ) : (
              <div className="flex h-full flex-col items-center justify-center gap-6" data-testid="interview-placeholder">
                <div className="relative">
                  <span className="animate-pulse-ring absolute inset-0 rounded-full bg-ember" />
                  <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-ember text-sand shadow-[0_10px_40px_-10px_rgba(217,93,57,0.8)]">
                    <Play size={30} className="ml-1 fill-current" />
                  </div>
                </div>
                <div className="text-center px-6">
                  <p className="font-display font-bold text-sand text-xl">The full interview premieres soon</p>
                  <p className="font-mono-brand text-xs uppercase tracking-[0.3em] text-sand/40 mt-2">
                    EduPower Originals
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
